import {
    VEICULO_MODO_TELA,
    VEICULO_SET_AGUARDANDO,
    VEICULO_LISTADO
} from './veiculoActions';

const INITIAL_STATE = {
    registro: {},
    modoTela: 'lista',
    aguardando: false,
    lista: [],
    listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case VEICULO_MODO_TELA:
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro || {}
            };

        case VEICULO_SET_AGUARDANDO:
            return {
                ...state,
                aguardando: action.payload
            };

        case VEICULO_LISTADO: {
            const lista = action.payload.data || [];

            return {
                ...state,
                lista,
                listaSelect: lista.map(item => ({
                    id: item.id,
                    valor: item.placa_nome
                }))
            };
        }

        default:
            return state;
    }
};